export default __webpack_public_path__ + "static/media/tile-term.709ae5d5.png";